module.exports = __webpack_public_path__ + "img/footer-4.e53b8ea5.gif";